import { useQuery } from '@tanstack/react-query';

import bundlesService from '~/services/cruises/BundlesService';

import { bundleQueryKeys } from './bundleQueryKeys';

const RECORDS_PER_PAGE = 15;

export function useGetBundles(page: number) {
  const skip = (page - 1) * RECORDS_PER_PAGE;

  return useQuery({
    queryKey: bundleQueryKeys.list({ page }),
    queryFn: () => bundlesService.listWithPagination({ skip, take: RECORDS_PER_PAGE }),
  });
}

export { RECORDS_PER_PAGE };
